import {Col, FormControl, Row} from "react-bootstrap";
import Resources from "../../../Resources/Resources";
import {toCurrencyNoDecimal, toCurrency, NassauLog} from "../../../scripts/myga-utils";
import React, {useEffect, useState} from "react";
import {MM_CALCULATOR, MM_PRODUCT, MM_PRODUCT_VISUALS} from "../../../scripts/myga-model";
import PopoverTooltip from "../../../components/PopoverTooltip";
import "./ProductStore.css";
import CurrencyInput from "../../../components/CurrencyInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import useDebounce from "../../../scripts/UseDebounce";

function ProductCardSimpleAnnuity(props) {

  let product = props.product;
  let calc = product[MM_PRODUCT.calculator];
  const surrenderPeriod = calc[MM_CALCULATOR.surrenderPeriod];
  const calcValue = calc[MM_CALCULATOR.calculateValue];
  const calcInterest = calc[MM_CALCULATOR.calculateInterest];
  const premiumMin = calc[MM_CALCULATOR.premiumMin];
  const premiumMax = calc[MM_CALCULATOR.premiumMax];
  const premiumInit = calc[MM_CALCULATOR.premium]
  const sliderMin = 0;
  const sliderMax = 1000;
  const sliderInc = 1;
  const premiumInc = 250;
  const currencyOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  };
  const placeholder = `${premiumMin.toLocaleString('en-US', currencyOptions)} to ${premiumMax.toLocaleString('en-US', currencyOptions)}`;
  
  let visuals = product[MM_PRODUCT.visuals];
  let cardColor = props.cardColor || visuals[MM_PRODUCT_VISUALS.cardColor];
  const card = {
    background: `radial-gradient(ellipse at top left, ${hexLighten(cardColor,0.2)}, ${hexLighten(cardColor,-0.2)})`
  };
  
  const isCustomized = product[MM_PRODUCT.customized];
  const isEditing = props.editing || false;
  const hideEditButton = props.hideEditButton || false;
  
  const payments = props.payments || [];
  const hidePayments = props.hidePayments || false;
  
  const cardRef = React.useRef();
  
  let [premium, setPremium] = useState(Math.max(premiumMin,calc[MM_CALCULATOR.premium]));
  
  // Limit the premium slider update rate to the container
  const premiumDebounced = useDebounce(premium);
  const onPremiumChange = props.onPremiumChange;
  useEffect(()=>{
    if (onPremiumChange) {
      NassauLog(`onPremiumChange: ${premiumDebounced}`)
      onPremiumChange(Number.parseFloat(premiumDebounced));
    }
  },[premiumDebounced,onPremiumChange]);
  
  
  useEffect(()=>{
    if (premium!==premiumInit) {
      product[MM_PRODUCT.userModified] = true
    }
  },[premium,premiumInit])
  
  const getPremium = () => isEditing?premium:calc[MM_CALCULATOR.premium];
  
  const editButton = (cb) => {
    return (
        <button type="button"
                className="btn btn-link btn-lg"
                onClick={cb}>
          <FontAwesomeIcon className={'edit-pencil-icon'} icon={Resources.Icons.Pencil}/>
        </button>
    )
  }
  
  const toProperCase = (val) => {
    return val.charAt(0).toUpperCase() + val.slice(1);
  }
  
  const premiumFromSlider = (x) => {
    const sliderRange = sliderMax - sliderMin
    let a = (premiumMax-premiumMin)/(sliderRange*sliderRange);
    return Math.ceil(Math.min(Math.floor((a*x*x) + premiumMin),premiumMax) / premiumInc) * premiumInc;
  }
  const sliderFromPremium = (y) => {
    const sliderRange = sliderMax - sliderMin
    let a = (premiumMax-premiumMin)/(sliderRange*sliderRange);
    return Math.sqrt(Math.max(0,(y-premiumMin))/a);
  }
  
  return (
      <div>
        <div className={`product-card noselect`}
             ref={cardRef}
             style={card}
             onClick={(e)=>{
             if (props.onClick)  {props.onClick(e);}
           }}>
          
          {/* company logo row */}
          <Row className="">
            <Col className="">
              <img className="product-logo" src={visuals[MM_PRODUCT_VISUALS.logoUrl]} alt="Logo"/>
            </Col>
            <div>
              <div>
      
              </div>
            </div>
          </Row>
          {/* product title row */}
          <Row>
            <Col className="font-page-larger-white pr-0 mr-0">
              {visuals[MM_PRODUCT_VISUALS.title]}<sup>{visuals[MM_PRODUCT_VISUALS.tradeMark]}</sup>
            </Col>
          </Row>
          {/* product surrender period row */}
          <Row className={'pb-1'}>
            <Col className="font-page-larger-white">
              <strong>{visuals[MM_PRODUCT_VISUALS.surrenderPeriod]}</strong>&nbsp;
              {visuals[MM_PRODUCT_VISUALS.surrenderPeriodLabel]}
            </Col>
          </Row>
          {/* premium row */}
          <Row>
            <Col className="offset-sm-1 text-left">
              <div className={'product-amount-container'}>
                {
                  isEditing ? (
                      <div className={'font-page-huge-white'}>
                        <CurrencyInput
                          id={'product-premium-amount'}
                          className={'product-amount-input '}
                          decimalsEnabled={false}
                          max={premiumMax}
                          value={premium}
                          handleChange={setPremium}
                          placeholder={placeholder}
                        />
                      </div>
                  ) : hideEditButton ? (
                      <div className={`product-amount-label font-page-huge-white mt-auto`}>
                        {toCurrencyNoDecimal(calc[MM_CALCULATOR.premium])}
                      </div>
                  ) : (
                      <div className={`product-amount-label editable font-page-huge-white mt-auto`}>
                        {toCurrencyNoDecimal(calc[MM_CALCULATOR.premium])}
                      </div>
                  )
                }
                {
                  (!hideEditButton && !isEditing) && (
                      <div className={'font-page-regular-white mt-auto mb-auto pl-2'}>
                        <FontAwesomeIcon icon={Resources.Icons.Pencil}/>&nbsp;Select your premium amount
                      </div>
                  )
                }
              </div>
            </Col>
          </Row>
          {/* withdrawal rate row*/}
          <Row className={'pb-0'}>
            <Col className="offset-sm-1 font-page-regular-white text-left mr-0 pr-0">
              {visuals[MM_PRODUCT_VISUALS.withdrawalRateInfo]()}
            </Col>
            {/*<Col className={'offset-sm-1 col-auto ml-0 pl-0'}>*/}
            {/*  <PopoverTooltip content={Resources.Strings.Deposit_InfoWithdrawals}*/}
            {/*                  buttonColor={'#ffffff'}/>*/}
            {/*</Col>*/}
          </Row>
          {/* premium range row */}
          <Row className={'pb-0'}>
            <Col className="offset-sm-1 font-page-regular-white text-left mr-0 pr-0">
              <div className="font-page-regular-white mt-auto pb-1">
                {`Premium Range ${toCurrencyNoDecimal(premiumMin)} to ${toCurrencyNoDecimal(premiumMax)}`}
              </div>
            </Col>
          </Row>
          {/* slider row */}
          {
            isCustomized && isEditing && (
                <Row className={""}>
                  <Col className={""}>
                    <FormControl type={'range'} className={"deposit-slider"}
                                 min={sliderMin}
                                 max={sliderMax}
                                 step={sliderInc}
                                 value={sliderFromPremium(premium)}
                                 onChange={e=>setPremium(premiumFromSlider(e.target.value))}
                    />
                  </Col>
                </Row>
            )
          }
          {/* yield information row */}
          {
            isCustomized && (
                <>
                  <Row>
                    <Col className={'offset-sm-1 font-page-regular-white text-left'}>
                      Future Value:
                    </Col>
                    <Col className={'col-auto font-page-regular-white text-right mr-sm-5'}>
                      {toCurrency(calcValue(getPremium(),surrenderPeriod))}
                    </Col>
                  </Row>
                  <Row>
                    <Col className={'offset-sm-1 font-page-regular-white text-left'}>
                      Total Interest Earned:
                    </Col>
                    <Col className={'col-auto font-page-regular-white text-right mr-sm-5'}>
                      {toCurrency(calcInterest(getPremium(),surrenderPeriod))}
                    </Col>
                  </Row>
                  <Row>
                    <Col className={'offset-sm-1 font-page-regular-white text-left'}>
                      First-Year Interest:
                    </Col>
                    <Col className={'col-auto font-page-regular-white text-right mr-sm-5'}>
                      {toCurrency(calcInterest(getPremium(),1))}
                    </Col>
                  </Row>
                </>
            )
          }
        </div>
        {
          !hidePayments && payments.length>0 ? (
              <div className={'disclosure-dark product-payment-card noselect'}>
                {/* 2021.10.04.ADivelbiss - Always show the disclosure since the future value is always displayed per Compliance this date.*/}
                <Row className={'text-center'}>
                  <Col className={'text-center'}>
                    <PopoverTooltip
                        placement={'top'}
                        containerRef={cardRef}
                        trigger={['click']}
      
                        content={
                          <div className={'product-disclosure-card-content'} >
                            {visuals[MM_PRODUCT_VISUALS.importantDisclosures]}
                          </div>
                        }
                    >
                      <div className={'product-disclosure-card-button-text'}>
                        {'Important Information'}
                      </div>
                    </PopoverTooltip>
                  </Col>
                </Row>
  
                <Row className={''}>
                  <Col className="font-page-large">
                    {'Payments: '}
                    {editButton(props.onEditPayments)}
                  </Col>
                </Row>
                {
                  payments.map((payment, index) => {
                    return (
                        <Row key={index}>
                          <Col className={'offset-sm-1 font-page-regular text-left'}>
                            {toProperCase(payment.paymentType)}
                          </Col>
                          <Col className={'col-auto font-page-regular text-right mr-sm-5'}>
                            {toCurrencyNoDecimal(parseFloat(payment.amount))}
                          </Col>
                        </Row>
                    );
                  })
                }
              </div>
          ) : (
              <Row className={'product-disclosure-card-row'}>
                <Col className="font-page-regular col-auto">
                  <div className={'disclosure-dark product-disclosure-card noselect'}>
                      <PopoverTooltip
                          placement={'top'}
                          containerRef={cardRef}
                          trigger={['click']}
                          
                          content={
                            <div className={'product-disclosure-card-content'} >
                              {visuals[MM_PRODUCT_VISUALS.importantDisclosures]}
                            </div>
                          }
                          >
                        <div className={'product-disclosure-card-button-text'}>
                          {'Important Information'}
                        </div>
                      </PopoverTooltip>
                  </div>
                </Col>
              </Row>
          )
        }
      </div>

  );
}

const hexLighten = (hex, amount = 0.05) =>{
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i
      .exec(hex)
      .slice(1)
      .filter(v=>v!==undefined)
      .map(v=>Math.floor(parseInt(v,16)*(1+amount)))
      .map(v=>Math.max(Math.min(v,255),0))
      .map(v=>v.toString(16).padStart(2,'0'))
      .join('')
      .toUpperCase();
  return `#${result}`;
}

export default ProductCardSimpleAnnuity;